import { createApp } from "vue";
import App from "./App.vue";
import http from "./http";
import VueAxios from "vue-axios";
import router from "./router";
import store from "./store";
import auth from "./auth";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHomeAlt as falHomeAlt,
  faChevronLeft as falChevronLeft,
  faChevronsLeft as falChevronsLeft,
  faChevronRight as falChevronRight,
  faChevronsRight as falChevronsRight,
  faBarsSort as falBarsSort,
  faEye as falEye,
  faEyeSlash as falEyeSlash,
  faFolderTree as falFolderTree,
  faPersonDigging as falPersonDigging,
  faTableTree as falTableTree,
  faFile as falFile,
  faFileCsv as falFileCsv,
  faFileAudio as falFileAudio,
  faFileHeart as falFileHeart,
  faFileImage as falFileImage,
  faFileLines as falFileLines,
  faFilePdf as falFilePdf,
  faFilePowerpoint as falFilePowerpoint,
  faFileVideo as falFileVideo,
  faFileWord as falFileWord,
  faFileSpreadsheet as falFileSpreadsheet,
  faUsers as falUsers,
  faChartPie as falChartPie,
  faBuildings as falBuildings,
  faQuestionCircle as falQuestionCircle,
  faBiohazard as falBiohazard,
  faPlus as falPlus,
} from "@fortawesome/pro-light-svg-icons";
import {
  faPlus as fasPlus,
  faMinus as fasMinus,
  faEye as fasEye,
  faFolder as fasFolder,
  faFolders as fasFolders,
  faFolderArrowDown as fasFolderArrowDown,
  faFolderArrowUp as fasFolderArrowUp,
  faFolderBlank as fasFolderBlank,
  faFolderBookmark as fasFolderBookmark,
  faFolderGear as fasFolderGear,
  faFolderGrid as fasFolderGrid,
  faFolderHeart as fasFolderHeart,
  faFolderImage as fasFolderImage,
  faFolderMedical as fasFolderMedical,
  faFolderMinus as fasFolderMinus,
  faFolderMusic as fasFolderMusic,
  faFolderPlus as fasFolderPlus,
  faFolderUser as fasFolderUser,
  faFolderXmark as fasFolderXmark,
  faFolderOpen as fasFolderOpen,
  faPenToSquare as fasPenToSquare,
  faTrashCan as fasTrashCan,
  faFileCirclePlus as fasFileCirclePlus,
  faFileArrowDown as fasFileArrowDown,
  faMoon as fasMoon,
  faSunBright as fasSunBright,
  faSpinnerThird as fasSpinnerThird,
  faComments as fasComments,
  faCloudArrowDown as fasCloudArrowDown,
  faShare as fasShare,
  faIcons as fasIcons,
  faRectangleHistory as fasRectangleHistory,
  faClockRotateLeft as fasClockRotateLeft,
  faUsers as fasUsers,
  faBuildings as fasBuildings,
  faFiles as fasFiles,
  faToolbox as fasToolbox,
  faFileExclamation as fasFileExclamation,
  faFileCircleInfo as fasFileCircleInfo,
  faFileMagnifyingGlass as fasFileMagnifyingGlass,
  faFileSlash as fasFileSlash,
  faCopy as fasCopy,
  faMagnifyingGlass as fasMagnifyingGlass,
  faFilePlus as fasFilePlus,
  faSortUp as fasSortUp,
  faSortDown as fasSortDown,
  faLeft as fasLeft,
} from "@fortawesome/pro-solid-svg-icons";
import { faSort } from "@fortawesome/pro-regular-svg-icons";
import { faSpinnerThird as fadSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import vSelect from "vue-select";
import "bootstrap";
import VueZoomer from "vue-zoomer";
import Popper from "vue3-popper";
import dayjs from "dayjs";
require("dayjs/locale/es");

library.add(
  falHomeAlt,
  falChevronLeft,
  falChevronsLeft,
  falChevronRight,
  falChevronsRight,
  falBarsSort,
  falEye,
  falEyeSlash,
  falFolderTree,
  falPersonDigging,
  falTableTree,
  falFile,
  falFileCsv,
  falFileAudio,
  falFileHeart,
  falFileImage,
  falFileLines,
  falFilePdf,
  falFilePowerpoint,
  falFileVideo,
  falFileWord,
  falFileSpreadsheet,
  falUsers,
  falChartPie,
  falBuildings,
  falQuestionCircle,
  falBiohazard,
  falPlus,
  fasMagnifyingGlass
);
library.add(
  fasPlus,
  fasMinus,
  fasEye,
  fasFolder,
  fasFolderMedical,
  fasPenToSquare,
  fasTrashCan,
  fasFolders,
  fasFolderArrowDown,
  fasFolderArrowUp,
  fasFolderBlank,
  fasFolderBookmark,
  fasFolderGear,
  fasFolderGrid,
  fasFolderHeart,
  fasFolderImage,
  fasFolderMinus,
  fasFolderMusic,
  fasFolderPlus,
  fasFolderUser,
  fasFolderXmark,
  fasFolderOpen,
  fasFileCirclePlus,
  fasFileArrowDown,
  fasMoon,
  fasSunBright,
  fasSpinnerThird,
  fasComments,
  fasShare,
  fasCloudArrowDown,
  fasIcons,
  fasRectangleHistory,
  fasClockRotateLeft,
  fasUsers,
  fasBuildings,
  fasFiles,
  fasToolbox,
  fasFileExclamation,
  fasFileCircleInfo,
  fasFileMagnifyingGlass,
  fasFileSlash,
  fasFilePlus,
  fasSortUp,
  fasSortDown,
  fasLeft,
  fasCopy
);
library.add(fadSpinnerThird);
library.add(faSort);

const app = createApp(App)
  .use(VueSweetalert2)
  .use(VueAxios, http)
  .use(store)
  .use(router)
  .use(auth)
  .use(VueZoomer)
  .use(Popper)
  .component("v-select", vSelect)
  .component("font-awesome-icon", FontAwesomeIcon);
app.config.globalProperties.$dayjs = dayjs;
app.config.globalProperties.$dayjs.locale("es");
app.mount("#app");
